import { createAction } from 'redux-actions'

const SET_FILTERS = 'SET_FILTERS'
const setFilters = createAction(SET_FILTERS)

function filters(state = {}, { type, payload }) {
  switch (type) {
    case SET_FILTERS:
      return payload
    default:
      return state
  }
}

const SET_PAGE_TYPE = 'SET_PAGE_TYPE'
const setPageType = createAction(SET_PAGE_TYPE)

function pageType(state = window.pageType || null, { type, payload }) {
  switch (type) {
    case SET_PAGE_TYPE:
      return payload
    default:
      return state
  }
}

export { setFilters, filters, setPageType, pageType }
